export enum Status {
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
  SCHEDULED = 'SCHEDULED',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  CLOSED = 'CLOSED',
  ONLINE = 'ONLINE',
  WAITING_LIST = 'WAITING_LIST'
}
